export default {
  header: `'Raleway', sans-serif`,
  text: `'Montserrat', sans-serif`
}
